import axiosBase from "@/api/axiosBase_dante";

const state = {
  getKnowledge: "",
  getConversation: "",
  getQuestion: "",
  getLimit: 0,
  getMessages: "",

}

const mutations = {
  setGetKnowledge(state, data) {
    state.getKnowledge = data
  },

  setGetConversation(state, data) {
    state.getConversation = data
  },

  setGetQuestion(state, data) {
    state.getQuestion = data
  },

  setGetLimit(state, data) {
    state.getLimit = data
  },

  setGetMessages(state, data) {
    state.getMessages = data
  },



}

const actions = {
  // 获取知识库
  getKnowledge({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/dante/knowledge',
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setGetKnowledge', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 创建聊天/获取聊天
  getConversation({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/dante/conversation/' + data,
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setGetConversation', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 提问
  getQuestion({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/dante/query-stream/' + data.question + "/" + data.cid,
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setGetQuestion', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取提问次数
  getLimit({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/dante/limit',
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.message }, { root: true });
          }
          else {
            commit('setGetLimit', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 分页获取历史问答 
  getMessages({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/dante/messages?knowledgeId=' + data.knowledgeId + "&pageNum=" + data.pageNum + "&pageSize=" + data.pageSize, 
      })
        .then(res => {
          if (res.data.code != 200) {
            commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
          }
          else {
            commit('setGetMessages', res.data.data);
          }
          resolve(res)
        })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },


    




}

const getters = {
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}